import { fromJS } from 'immutable';
import * as actions from '@actions/conference';
import { SUCCESS, START, ERROR } from '@actions/global';
import { fetchingState } from '@constants';

const initialcount = 0;
const defaultPage = 1;
const defaultRowsPerPage = 40;
const defaultRowsPerPageOptions = [40, 80, 120, 1000];

const initialState = {
  codeFiles: { data: {}, state: null },
  conferences: {
    current: {
      data: [],
      state: null,
      pagination: {
        count: initialcount,
        page: defaultPage,
        rowsPerPage: defaultRowsPerPage,
        rowsPerPageOptions: defaultRowsPerPageOptions,
      },
    },
    past: {
      data: [],
      state: null,
      pagination: {
        count: initialcount,
        page: defaultPage,
        rowsPerPage: defaultRowsPerPage,
        rowsPerPageOptions: defaultRowsPerPageOptions,
      },
    },
  },
  helpSessions: {
    current: {
      data: [],
      state: null,
      pagination: {
        count: initialcount,
        page: defaultPage,
        rowsPerPage: defaultRowsPerPage,
        rowsPerPageOptions: defaultRowsPerPageOptions,
      },
    },
    past: {
      data: [],
      state: null,
      pagination: {
        count: initialcount,
        page: defaultPage,
        rowsPerPage: defaultRowsPerPage,
        rowsPerPageOptions: defaultRowsPerPageOptions,
      },
    },
  },
  meeting: {
    activeConference: {},
    conferenceMeta: {},
    instance: null,
    messages: [],
    permissionChecks: {},
    endMeetingOptions: {},
  },
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case actions.FETCH_CODE_FILE[SUCCESS]:
      return state.setIn(
        ['codeFiles', 'data', action.name],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.SET_ACTIVE_CONFERENCE: {
      return state.setIn(
        ['meeting', 'activeConference'],
        action.payload ? action.payload : {},
      );
    }
    case actions.SET_CONFERENCE_META: {
      return state.setIn(
        ['meeting', 'conferenceMeta'],
        action.payload ? action.payload : {},
      );
    }

    case actions.FETCH_PERMISSION_CHECKS[SUCCESS]: {
      return state.setIn(
        ['meeting', 'permissionChecks'],
        action.data ? action.data.results : {},
      );
    }

    case actions.SET_AWS_CHIMES_DATA: {
      return state.setIn(['meeting', 'instance'], action.data || null);
    }
    case actions.ADD_AWS_CHIMES_CHAT:
      return state.setIn(
        ['meeting', 'messages'],
        [...state.getIn(['meeting', 'messages']), action.data],
      );
    case actions.INIT_AWS_CHIMES_CHAT:
      return state.setIn(['meeting', 'messages'], action.data);
    case actions.UPDATE_MEETING_ATTENDEE_INFO: {
      if (state.getIn(['meeting', 'instance'])) {
        return state.setIn(
          ['meeting', 'instance', 'attendeeInfo'],
          action.data,
        );
      }
      return state;
    }
    case actions.FETCH_CURRENT_CONFERENCES[START]:
      return state.setIn(
        ['conferences', 'current', 'state'],
        fetchingState.FETCHING,
      );
    case actions.FETCH_CURRENT_CONFERENCES[SUCCESS]: {
      return state
        .setIn(['conferences', 'current', 'state'], fetchingState.LOADED)
        .setIn(
          ['conferences', 'current', 'data'],
          fromJS(action.data ? action.data.results : []),
        )
        .setIn(
          ['conferences', 'current', 'pagination', 'count'],
          action.data ? action.data.totalConferences : 0,
        );
    }
    case actions.FETCH_CURRENT_CONFERENCES[ERROR]:
      return state.setIn(
        ['conferences', 'current', 'state'],
        fetchingState.ERROR,
      );

    case actions.FETCH_PAST_CONFERENCES[START]:
      return state.setIn(
        ['conferences', 'past', 'state'],
        fetchingState.FETCHING,
      );
    case actions.FETCH_PAST_CONFERENCES[SUCCESS]: {
      return state
        .setIn(['conferences', 'past', 'state'], fetchingState.LOADED)
        .setIn(
          ['conferences', 'past', 'data'],
          fromJS(action.data ? action.data.results : []),
        )
        .setIn(
          ['conferences', 'past', 'pagination', 'count'],
          action.data ? action.data.totalConferences : 0,
        );
    }
    case actions.FETCH_PAST_CONFERENCES[ERROR]:
      return state.setIn(['conferences', 'past', 'state'], fetchingState.ERROR);

    case actions.FETCH_CURRENT_HELP_SESSIONS[START]:
      return state.setIn(
        ['helpSessions', 'current', 'state'],
        fetchingState.FETCHING,
      );
    case actions.FETCH_CURRENT_HELP_SESSIONS[SUCCESS]: {
      return state
        .setIn(['helpSessions', 'current', 'state'], fetchingState.LOADED)
        .setIn(
          ['helpSessions', 'current', 'data'],
          fromJS(action.data ? action.data.results : []),
        )
        .setIn(
          ['helpSessions', 'current', 'pagination', 'count'],
          action.data ? action.data.totalConferences : 0,
        );
    }
    case actions.FETCH_CURRENT_HELP_SESSIONS[ERROR]:
      return state.setIn(
        ['helpSessions', 'current', 'state'],
        fetchingState.ERROR,
      );

    case actions.FETCH_PAST_HELP_SESSIONS[START]:
      return state.setIn(
        ['helpSessions', 'past', 'state'],
        fetchingState.FETCHING,
      );
    case actions.FETCH_PAST_HELP_SESSIONS[SUCCESS]: {
      return state
        .setIn(['helpSessions', 'past', 'state'], fetchingState.LOADED)
        .setIn(
          ['helpSessions', 'past', 'data'],
          fromJS(action.data ? action.data.results : []),
        )
        .setIn(
          ['helpSessions', 'past', 'pagination', 'count'],
          action.data ? action.data.totalConferences : 0,
        );
    }
    case actions.FETCH_PAST_HELP_SESSIONS[ERROR]:
      return state.setIn(
        ['helpSessions', 'past', 'state'],
        fetchingState.ERROR,
      );

    case actions.CHANGE_PAGE: {
      return state.setIn(
        ['conferences', 'current', 'pagination', 'page'],
        action.payload,
      );
    }
    case actions.CHANGE_ROWS_PER_PAGE: {
      return state.setIn(
        ['conferences', 'current', 'pagination', 'rowsPerPage'],
        action.payload,
      );
    }
    case actions.CHANGE_PAGE_PAST: {
      return state.setIn(
        ['conferences', 'past', 'pagination', 'page'],
        action.payload,
      );
    }
    case actions.CHANGE_ROWS_PER_PAGE_PAST: {
      return state.setIn(
        ['conferences', 'past', 'pagination', 'rowsPerPage'],
        action.payload,
      );
    }

    case actions.CHANGE_HELP_SESSIONS_PAGE: {
      return state.setIn(
        ['helpSessions', 'current', 'pagination', 'page'],
        action.payload,
      );
    }
    case actions.CHANGE_HELP_SESSIONS_ROWS_PER_PAGE: {
      return state.setIn(
        ['helpSessions', 'current', 'pagination', 'rowsPerPage'],
        action.payload,
      );
    }
    case actions.CHANGE_HELP_SESSIONS_PAGE_PAST: {
      return state.setIn(
        ['helpSessions', 'past', 'pagination', 'page'],
        action.payload,
      );
    }
    case actions.CHANGE_HELP_SESSIONS_ROWS_PER_PAGE_PAST: {
      return state.setIn(
        ['helpSessions', 'past', 'pagination', 'rowsPerPage'],
        action.payload,
      );
    }

    case actions.SET_END_MEETING_OPTIONS: {
      return state.setIn(['meeting', 'endMeetingOptions'], action.payload);
    }
    default:
      return state;
  }
};
